import { Component, inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { SafeHtml } from "@angular/platform-browser";

export interface ConfirmDialogData
{
    readonly title?: string;
    readonly message: SafeHtml;
    readonly okLabel?: string;
    readonly cancelLabel?: string;
}

@Component({
    selector: "confirm-dialog",
    templateUrl: "./confirm.tmpl.html",
    standalone: false
})
export class ConfirmDialogComponent
{
    private readonly dialogRef = inject<MatDialogRef<ConfirmDialogComponent, boolean>>(MatDialogRef);
    private readonly data = inject<ConfirmDialogData>(MAT_DIALOG_DATA);


    get title(): string { return this.data.title ?? "Confirm"; }
    get message(): SafeHtml { return this.data.message; }
    get okLabel(): string { return this.data.okLabel ?? "Yes"; }
    get cancelLabel(): string { return this.data.cancelLabel ?? "No"; }

    accept(): void
    {
        this.dialogRef.close(true);
    }

    cancel(): void
    {
        this.dialogRef.close(false);
    }
}
